import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.updateSelectionState()
  }

  export(event) {
    event.preventDefault()
    
    let table
    const tableId = event.currentTarget.dataset.tableId
    
    if (tableId) {
      table = document.getElementById(tableId)
    } else {
      table = event.currentTarget.closest('.table-responsive')?.querySelector('table') || 
              event.currentTarget.parentElement.querySelector('table')
    }
    
    if (!table) {
      console.error('Table not found')
      return
    }
    
    const csvContent = this.tableToCSV(table)
    const customFilename = event.currentTarget.dataset.filename
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
    const filename = customFilename ? `${customFilename}-${timestamp}.csv` : `table_export_${timestamp}.csv`
    
    this.downloadCSV(csvContent, filename)
  }

  exportSelected(event) {
    event.preventDefault()

    const table = this.selectionTable
    if (!table) return

    const selectedRows = this.rowCheckboxes
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.closest("tr"))
      .filter(Boolean)

    if (selectedRows.length === 0) return

    const csvContent = this.tableToCSV(table, { rows: selectedRows, excludedColumnIndexes: this.excludedColumnIndexes(table) })
    const customFilename = event.currentTarget.dataset.filename || "selected-employees"
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
    this.downloadCSV(csvContent, `${customFilename}-${timestamp}.csv`)
  }

  toggleAll() {
    const selectAllCheckbox = this.selectAllCheckbox
    if (!selectAllCheckbox) return

    this.rowCheckboxes.forEach((checkbox) => {
      checkbox.checked = selectAllCheckbox.checked
    })

    this.updateSelectionState()
  }

  updateSelection() {
    this.updateSelectionState()
  }
  
  tableToCSV(table, options = {}) {
    const rows = options.rows || Array.from(table.querySelectorAll("tbody tr"))
    const excludedColumnIndexes = options.excludedColumnIndexes || []
    const csvRows = []
    const headerRow = table.querySelector("thead tr")

    if (headerRow) {
      const headers = this.cellsToCSVRow(headerRow.querySelectorAll("th, td"), excludedColumnIndexes)
      if (headers.length > 0) csvRows.push(headers.join(","))
    }

    rows.forEach((row) => {
      const cells = this.cellsToCSVRow(row.querySelectorAll("th, td"), excludedColumnIndexes)
      if (cells.length > 0) csvRows.push(cells.join(","))
    })

    return csvRows.join('\n')
  }

  cellsToCSVRow(cells, excludedColumnIndexes = []) {
    const rows = []

    cells.forEach((cell, index) => {
      if (excludedColumnIndexes.includes(index)) return

      let cellText = cell.textContent.trim()
      if (cellText.includes(',') || cellText.includes('"') || cellText.includes('\n')) {
        cellText = '"' + cellText.replace(/"/g, '""') + '"'
      }
      rows.push(cellText)
    })

    return rows
  }
  
  downloadCSV(csvContent, filename) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  updateSelectionState() {
    const rowCheckboxes = this.rowCheckboxes
    const selectedCount = rowCheckboxes.filter((checkbox) => checkbox.checked).length
    const totalCount = rowCheckboxes.length
    const exportButton = this.exportButton
    const selectAllCheckbox = this.selectAllCheckbox

    if (exportButton) {
      exportButton.disabled = selectedCount === 0
    }

    if (selectAllCheckbox) {
      selectAllCheckbox.checked = totalCount > 0 && selectedCount === totalCount
      selectAllCheckbox.indeterminate = selectedCount > 0 && selectedCount < totalCount
    }
  }

  excludedColumnIndexes(table) {
    return [0, this.lastColumnIndex(table)].filter((index, position, array) => index >= 0 && array.indexOf(index) === position)
  }

  lastColumnIndex(table) {
    const headerCells = table ? table.querySelectorAll("thead tr th, thead tr td") : []
    return headerCells.length > 0 ? headerCells.length - 1 : -1
  }

  get selectionTable() {
    return this.element.querySelector("[data-csv-export-table='selection']")
  }

  get rowCheckboxes() {
    return Array.from(this.element.querySelectorAll("[data-csv-export-row-checkbox='true']"))
  }

  get selectAllCheckbox() {
    return this.element.querySelector("[data-csv-export-select-all='true']")
  }

  get exportButton() {
    return this.element.querySelector("[data-csv-export-button='selection']")
  }
}
